import { render } from "./ViewCounter.vue?vue&type=template&id=17bcce65&scoped=true"
import script from "./ViewCounter.vue?vue&type=script&lang=js"
export * from "./ViewCounter.vue?vue&type=script&lang=js"

import "./ViewCounter.vue?vue&type=style&index=0&id=17bcce65&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\zacha\\repos\\jhhe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bcce65"]])

export default __exports__